import { createIcon } from './IconPrimitive';

export const KeyboardArrowUpIcon = createIcon(
  'KeyboardArrowUpIcon',
  <path d="M6.245 15.749a.93.93 0 0 1-1.293 0 .875.875 0 0 1 0-1.26l6.401-6.237a.93.93 0 0 1 1.294 0l6.401 6.236a.875.875 0 0 1 0 1.26.93.93 0 0 1-1.293 0L12 10.143z" />
);
